import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { success, error } from "../common/helpers/toastify";
import { useTranslation } from "react-i18next";
import { toFormatPrice } from "../common/helpers/function";
import { useSelector } from "react-redux";
import { _Api } from "../common/api/_call";
import greentickimg from "../../assets/images/greentick.png"
import product_design from "../../assets/images/product_design.svg";
import chain_origin from "../../assets/images/chain_origin.svg";
import diamond_mine from "../../assets/images/diamond_mine.svg";
import metal_origin from "../../assets/images/metal_origin.svg";
import handcrafting from "../../assets/images/handcrafting.svg";
import qc_shipping from "../../assets/images/qc_shipping.svg";
import chainrelated from "../../assets/images/chainrelated.png";
import diamondrelated from "../../assets/images/diamondrelated.png";
import noinfoimg from "../../assets/images/noinfo.png"

const OrderTraceabilityModal = ({
    id = "OrderTraceabilityModal",
    items = [],
}) => {
    const { t } = useTranslation();
    const [selectedId, setSelectedId] = useState();
    const [traceData, setTraceData] = useState();
    const [traceDetail, setTraceDetail] = useState({});
  
    const iconMap = {
        "652e2c3f7ab8c5b2750a4f03": { icon: chain_origin, color: "#3484D4" },
        "652e2c3f7ab8c5b2750a4f04": { icon: chainrelated, color: "#3484D4" },
        "652e2c3f7ab8c5b2750a4f05": { icon: chainrelated, color: "#3484D4" },
        "652e2c3f7ab8c5b2750a4f08": { icon: diamond_mine, color: "#212121" },
        "652e2c3f7ab8c5b2750a4f09": { icon: diamondrelated, color: "#212121" },
        "652e2c3f7ab8c5b2750a4f06": { icon: diamondrelated, color: "#212121" },
        "652e2c3f7ab8c5b2750a4f07": { icon: diamondrelated, color: "#212121" },
        "652e2c3f7ab8c5b2750a4f0a": { icon: metal_origin, color: "#73AAE1" },
        "652e2c3f7ab8c5b2750a4f0b": { icon: handcrafting, color: "#87898C" },
        "652e2c3f7ab8c5b2750a4f0c": { icon: handcrafting, color: "#87898C" },
        "652e2c3f7ab8c5b2750a4f02": { icon: qc_shipping, color: "#73AB8B" },
    };

    const getTimelineData = (data) => {
        const timeline = [];

        // 1. Add product design at top
        timeline.push({
            id: "product_design",
            name: "Product Design",
            countries: [data?.product_design_trace ? data?.product_design_trace : []],
            transactionId: data?.product_design_trace_detail?.transactionId || "-",
            iconName: { icon: product_design, color: "#3C609C" },
        });

        // 2. Add traceability items sorted by iconMap order (reverse order)
        const iconMapOrder = [
            "652e2c3f7ab8c5b2750a4f03",
            "652e2c3f7ab8c5b2750a4f04",
            "652e2c3f7ab8c5b2750a4f05",
            "652e2c3f7ab8c5b2750a4f08",
            "652e2c3f7ab8c5b2750a4f09",
            "652e2c3f7ab8c5b2750a4f06",
            "652e2c3f7ab8c5b2750a4f07",
            "652e2c3f7ab8c5b2750a4f0a",
            "652e2c3f7ab8c5b2750a4f0b",
            "652e2c3f7ab8c5b2750a4f0c",
            "652e2c3f7ab8c5b2750a4f02",
        ];

        // Items in the defined order
        const orderedItems = iconMapOrder
            .filter((key) => data.traceability[key])
            .map((key) => ({
                id: key,
                ...data.traceability[key],
                iconName: iconMap[key]
                    ? iconMap[key]
                    : {
                        icon: "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png",
                        color: "#606060",
                    },
            }));

        // Items not in iconMapOrder (put at last)
        const unorderedItems = Object.keys(data.traceability)
            .filter((key) => !iconMapOrder.includes(key))
            .map((key) => ({
                id: key,
                ...data.traceability[key],
                iconName: iconMap[key]
                    ? iconMap[key]
                    : {
                        icon: "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png",
                        color: "#606060",
                    },
            }));

        timeline.push(...orderedItems, ...unorderedItems);
        return timeline;
    };

      const handleTraceData = (id, key) => {
        setSelectedId(id);
        const mainarray = [...items];
        const item = mainarray[key];

        const tracesDetail = {
            image: item?.main_image || "",
            name: item?.name || "",
            SKU: item?.SKU || "",
            pos_Qty: item?.po_QTY || 1,
            stock_id: item?.stock_id || "-",
            transactionId: item?.product_design_trace_detail?.transactionId,
        };
        setTraceDetail(tracesDetail);

        // safely extract traceability data
        const traceability = item?.traceability || {};
        const product_design_trace = item?.product_design_trace || {
            label: "Unknown",
            value: "",
        };
        const product_design_trace_detail = item?.product_design_trace_detail || {
            transactionId: "-",
        };

        const tracesData = {
            traceability,
            product_design_trace,
            product_design_trace_detail,
        };

        const arrtrace = getTimelineData(tracesData);
        setTraceData(arrtrace);
    };
        useEffect(()=>{
          if(items?.length){
            handleTraceData(items?.[0]?._id,0)
          }
    },[items])
    return (
        <div
            className="modal fade common-modal service-modal"
            id={id}
            tabIndex="-1"
            aria-labelledby="OrderTraceabilityModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-right-1 modal-lg">
                <div className="modal-content modal-content-1 modal1-border modal-top-div">
                    <div className="heading-div">
                        <h4 className="heading-div-head">{t("Traceability Origin")}</h4>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={()=>{
                                setSelectedId();
                                setTraceData();
                                setTraceDetail();
                            }}
                        ></button>
                    </div>

                    <div className="modal-body-border"></div>
                    <div style={{ display: "flex", height: "100%" }}>
                        <div
                            className="list-group"
                            style={{
                                borderRadius: "0",
                                width: "50%",
                                marginRight: "1vw",
                                marginTop: "0.2vw"
                            }}
                        >    <div style={{ display: 'flex', justifyContent: 'space-between', width: "100%" }}>

                                <div className="modal-title modal-trace-heading fw-bold d-flex" id="orderModalLabel" style={{ width: "80%" }}>
                                    {t("Select Item for Traceability Origin")}
                                </div>
                                <h5 className="modal-title modal-trace-heading fw-bold d-flex" id="orderModalLabel" style={{ justifyContent: "end", width: "20%" }}>
                                    {items?.length || 0}
                                </h5>

                            </div>
                            {items.map((item, index) => (
                                <div
                                    key={index}
                                    className="list-group-item d-flex align-items-center justify-content-between"
                                    onClick={() => handleTraceData(item._id,index)}
                                    // style={(index+1)%2==0? {backgroundColor: "#FAFAFA"} : {backgroundColor: "#F4F4F4"}}
                                    style={{ backgroundColor: selectedId === item._id ? "#E1F3F2" : (index + 1) % 2 === 0 ? "#FAFAFA" : "#F4F4F4", border: "none", marginTop: '0.3vw' }}
                                >
                                    <div className="d-flex justify-content-between" style={{ width: "90%" }}>
                                        <div className="form-check">
                                            {/* <input
                                          className="form-check-input"
                                          type="checkbox"
                                          value={item._id}
                                          checked={selectedId.includes(item._id)}
                                          name="orderItem"
                                          onChange={(e) => handleCheckboxChange(e)}
                                          style={{borderRadius: "0",border:"none"}}
                                        /> */}
                                            <div className="ms-2">
                                                <div className="fw-bold">{item.SKU}</div>
                                                {item?.stock_id ? <small className="text-muted d-flex">{item.stock_id}</small> : ""}
                                            </div>
                                        </div>
                                        <div className="text-end">
                                            {item?.po_QTY ? <div className="fw-bold">{item.po_QTY} pcs</div> : ""}
                                            <small className="text-muted">{toFormatPrice(item.price, { addSymbol: true })}</small>
                                        </div>
                                    </div>
                                    {
                                        selectedId === item._id ?
                                            <img
                                                src={greentickimg}
                                                alt="greentick"

                                            /> : ""
                                    }

                                </div>

                            ))}
                        </div>
                        
                        {selectedId?<div style={{ borderLeft: "1px solid #f2f2f2"}}>
                            <div className="modal-body-first-div">
                                <div className="img-div">
                                    <img
                                        className="img1"
                                        src={
                                            traceDetail?.image ||
                                            "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png"
                                        }
                                        alt="product-image"
                                        onError={(e) => {
                                            e.target.onerror = null; // prevent infinite loop
                                            e.target.src = "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png";
                                        }}
                                    />
                                </div>
                                <div className="trace-info">
                                    <h6 className="trace-title">
                                        {traceDetail?.name || "Product Name"}
                                    </h6>
                                    <div className="trace-SKU trace-SKU-subtext mb-1">
                                        {traceDetail?.SKU || "-"}
                                    </div>
                                    <div className="trace-SKU trace-SKU-subtext mb-1">
                                        {traceDetail?.stock_id || "-"}
                                    </div>
                                    <div className="trace-transactionId-div">
                                        <div className="trace-subtext d-flex" style={{ gap: "0.2vw" }}>
                                            <span className="trace-label">Transaction ID:</span>{" "}
                                            <span className="trace-label-value truncate-transactionId">
                                                {traceDetail?.transactionId || "-"}
                                            </span>
                                        </div>
                                        <p className="trace-subtext">
                                            <span className="trace-label">Quantity:</span>{" "}
                                            <span className="trace-label-value">
                                                {traceDetail?.pos_Qty || 0}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="traceability-timeline">
                                {traceData && traceData.length > 0 ? (
                                    traceData.map((trace, index) => (
                                        <div key={trace.id || index} className="timeline-item">
                                            <div className="timeline-icon-wrapper">
                                                <div className="timeline-icon">
                                                    <img src={trace.iconName?.icon} alt={trace.name} />
                                                </div>
                                                {index < traceData.length - 1 && (
                                                    <div className="timeline-connector"></div>
                                                )}
                                            </div>
                                            <div className="timeline-content">
                                                <h6 className="timeline-title" style={{ color: trace?.iconName?.color ? trace?.iconName?.color : "#606060" }}>{trace.name}</h6>
                                                <div className="timeline-details">
                                                    {trace.countries && trace.countries.length > 0 ? (
                                                        <span className="timeline-country" style={{ color: trace?.iconName?.color ? trace?.iconName?.color : "#606060" }}>
                                                            {trace.countries.map(c => c.label).join(", ")}
                                                        </span>
                                                    ) : null}
                                                    {trace.transactionId && trace.transactionId !== "-" && (
                                                        <span className="timeline-date">
                                                            {trace.dateTime}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="no-trace-data">
                                        <p>No traceability data available</p>
                                    </div>
                                )}
                            </div>
                        </div>:
                        <div style={{display:'flex',justifyContent:"center",alignItems:"center",width:"50%",flexDirection:"column"}}>
                               <img
                               src={noinfoimg}
                               alt="noinfo"
                               />
                           <span className="mt-1"style={{color:"#606060"}}>
                            No information available.
                            </span> 
                            <span className="mt-1">
                                Please select a card to display the traceability details.
                                </span>   
                            </div>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderTraceabilityModal;
